/* global __CLIENT__*/
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import '../../styles/MainContent.css';
import ProjectDefaultTabContainer from './TaskHome';



const viewsSelector = (state, props) => state.views.getIn(['views']);

const BreadcrumbsSelector = immutableCreatorSelector([viewsSelector], views => {
  return {
    views,
  };
});

@connect(BreadcrumbsSelector)
@withRouter
class Breadcrumbs extends Component {
  getPath = () => {
    const {
      location: { pathname },
      views,
    } = this.props;

    switch (true) {
      case /project\/.+\/element-type\/.+\/elements/.test(pathname):
        return ['Tasks and Milestones List'];
      case /project\/.+\/gantt/.test(pathname):
        return ['Gantt'];
      case /project\/.+\/dsm/.test(pathname):
        return ['DSM'];
      case /project\/.+\/view\/.+/.test(pathname): // TODO: handle views?
        const { viewId } = this.props.params;
        const view = views.get(viewId);
        if (view) return [view.get('name')];
        return [];
      case /project\/.+\/task-doctor/.test(pathname):
        return ['Task Doctor'];
      case /project\/.+\/settings/.test(pathname):
        return ['Settings'];
      case /project\/.+\/planner/.test(pathname):
        return ['Planner Dashboard'];
      default:
        return [];
    }
  };
  render() {
    const { project } = this.props;

    return (
      <nav aria-label="breadcrumb" style={{ paddingLeft: 15}}>
        <ol className="breadcrumb">
          <li className="breadcrumb-item active" aria-current="page">
            {project.get('name')}
          </li>
          {this.getPath().map(p => (
            <li className="breadcrumb-item active" aria-current="page">
              {p}
            </li>
          ))}
        </ol>
      </nav>
    );
  }
}

class MainContent extends Component {
  static propTypes = {
    content: PropTypes.object,
    project: PropTypes.instanceOf(Map),
    routeParams: PropTypes.object.isRequired,
  };

  render() {
    const { routeParams, project } = this.props;

    const tabContent = this.props.children ? (
      this.props.children
    ) : (
      <ProjectDefaultTabContainer routeParams={routeParams} />
    );
    console.log('routeParams', routeParams);
    return (
      <div className="right-col">
        <div className="main-col">
          <div className="main-content">
            <Breadcrumbs project={project} />
            {tabContent}
          </div>
        </div>
      </div>
    );
  }
}

export default class MainContentContainer extends Component {
  static propTypes = {
    content: PropTypes.object,
    project: PropTypes.instanceOf(Map),
    routeParams: PropTypes.object.isRequired,
  };

  render() {
    return <MainContent {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/Project/MainContent.js